import { Component, OnInit, Input, OnDestroy, ViewChild } from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import {
    ComplainRegister,
    ComplainSearch,
    Filter_Update_Request,
    Glitch_SearchRequest,
} from "../../Models/RequestModels";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import {
    CallStatuses,
    EntityCodes,
    ComplainSearch_GroupBy,
    AuthActionCodes,
    ModuleLicenceCodes,
    GlitchSearch_GroupBy,
    FilterTypes,
} from "../../Models/EnumModels";
import { PMSService } from "../../Services/PMSService";
import { GuestLookup, ListResponse } from "../../Models/ResponseModels";
import * as _ from "lodash";
import { ComplainService } from "../../Services/ComplainService";
import {
    TopFilterStatModel,
    SearchTextResult,
} from "../../Models/CommonModels";
import * as alasql from "alasql";
import {
    GenericMaster,
    GenericMaster_String,
    LocationLookup,
    CallDescriptionLookup,
    CallCategoryLookup,
    VIP,
    PropertyBasicInfo,
    GlitchDescription,
    GlitchCategory,
} from "../../Models/GlobalEntities";
import { Observable, of } from "rxjs";
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    map,
    tap,
    switchMap,
    retry,
} from "rxjs/operators";
import {
    NgbTypeaheadSelectItemEvent,
    NgbModal,
    NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { UserService } from "../../Services/UserService";
import { untilDestroyed } from "ngx-take-until-destroy";
import { GlitchService } from "../../Services/GlitchService";
import { GlitchSearchResult } from "../GlitchSearchResult/GlitchSearchResult";
import {AppSettings} from "../../Library/AppSettings";

@Component({
    selector: "GlitchConsole",
    templateUrl: "./GlitchConsole.html",
})
export class GlitchConsole extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild("grdSearchResult") grdSearchResult: GlitchSearchResult;
    @ViewChild("glConsoleKey") glConsoleKey;

    RequestModel: Glitch_SearchRequest;
    Model: ListResponse;
    _LocationId: number;
    DateFormat: string;
    PropStatModel: Array<TopFilterStatModel<number>> = [];
    Timer: any;
    cDate: Date = new Date();
    SortParams: Array<GenericMaster_String> = [];
    SearchOnEntities: Array<EntityCodes> = [
        EntityCodes.GlitchDescriptionMaster,
        EntityCodes.GlitchCategories,
        EntityCodes.Dept,
        EntityCodes.Location,
        EntityCodes.Sections,
        EntityCodes.Staff,
    ];

    lstLocations: Array<LocationLookup> = [];
    lstStaff: Array<GenericMaster> = [];
    lstGlitchDescription: Array<GlitchDescription> = [];
    lstGlitchCategories: Array<GlitchCategory> = [];
    lstDepartments: Array<GenericMaster> = [];
    lstSections: Array<GenericMaster> = [];
    lstProperties: Array<PropertyBasicInfo> = [];
    KeywordSearch: string = null;

    MasterCache: any = {};

    _GlitchSearch_GroupBy = GlitchSearch_GroupBy;
    GroupTypes: Array<GenericMaster> = [];

    SelectedProperties: Array<number> = [];

    EnabledFilters: Array<FilterTypes> = [
        FilterTypes.GlitchDescription,
        FilterTypes.GlitchCategory,
        FilterTypes.Location,
        FilterTypes.Dept,
        FilterTypes.GlitchStaff,
        FilterTypes.RegisteredBy,
        FilterTypes.TaggedStaffIds,
        FilterTypes.StaffsInvolved,
        FilterTypes.LoggedDate,
        FilterTypes.HasInvestigation,
        FilterTypes.HasRecovery,
        FilterTypes.Vip,
    ];
    AppSettings = AppSettings;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected pmsService: PMSService,
        public complainService: ComplainService,
        public userService: UserService,
        public glitchService: GlitchService,
        private modalService: NgbModal
    ) {
        super(translate, toastr, route, router, masterService);

        for (let row of Object.keys(GlitchSearch_GroupBy).filter(
            (a) => typeof GlitchSearch_GroupBy[a] === "number"
        )) {
            let obj = new GenericMaster();
            obj.Id = GlitchSearch_GroupBy[row];

            if (obj.Id == 0) {
                obj.Name = "CMB_DEF.NO_GROUPING";
            } else {
                obj.Name = "ENTITIES.ENTITIES_" + row.toString();
            }

            if (obj.Id == GlitchSearch_GroupBy.Property) {
                if (this.masterService.LoggedInUserData.Properties.length > 1)
                    this.GroupTypes.push(obj);
            } else {
                this.GroupTypes.push(obj);
            }
        }
    }

    ngOnDestroy(): void {
        window.clearInterval(this.Timer);
        this.glitchService.SelectedGlitch = null;
    }

    ngOnInit(): void {
        this.glitchService.RequireFullRefresh.pipe(
            untilDestroyed(this)
        ).subscribe((data) => {
            this.RefreshData();
        });

        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        this.lstProperties = this.masterService.GetProperties_Action(
            AuthActionCodes.GlitchView
        );

        this.InitRequestModel();

        this.PopulateTopFilters();
        this.SetTopStatusData();

        //this.onLoadFilter();

        this.SetData();

        this.CreateCache();
    }

    InitRequestModel(): void {
        this.RequestModel = new Glitch_SearchRequest();
        this.RequestModel.SetDefaults();

        this.SetSearchProperties();
    }

    SetSearchProperties(): void {
        if (
            this.SelectedProperties == null ||
            (this.SelectedProperties.length == 0 &&
                this.lstProperties.length > 0)
        ) {
            let propId = this.masterService.GetDefaultProperty_Action(
                AuthActionCodes.GlitchView
            );

            if (propId != null) this.SelectedProperties.push(propId);
        }

        this.RequestModel.Properties = _.cloneDeep(this.SelectedProperties);

        //for (let i = 0; i < this.masterService.LoggedInUserData.Properties.length; i++) {
        //    this.RequestModel.Properties.push(this.masterService.LoggedInUserData.Properties[i].PropertyId);
        //}
    }

    PopulateTopFilters(): void {
        this.PropStatModel.push({
            Id: null,
            IconClass: "fa fa-bars",
            Label: "SHORT_NAME.SHORT_NAME_ALL",
            Value: 0,
        });

        this.PropStatModel.push({
            Id: 1,
            IconClass: "fa fa-unlock-alt",
            Label: "SHORT_NAME.SHORT_NAME_OPN",
            Value: 0,
        });

        this.PropStatModel.push({
            Id: 0,
            IconClass: "fa fa-lock",
            Label: "SHORT_NAME.SHORT_NAME_CLS",
            Value: 0,
        });
    }

    FindStatus(Status): TopFilterStatModel<number> {
        return this.PropStatModel.find((value) => {
            return value.Id == Status;
        });
    }

    IsAllSelected() {
        let toReturn = true;
        for (let row of this.lstProperties) {
            if (this.idxPropSelectedDropDown(row.PropertyId) < 0) {
                toReturn = false;
            }
        }
        return toReturn;
    }

    IsSomeSelected() {
        let toReturn = false;
        let allSelected = true;
        for (let row of this.lstProperties) {
            if (this.idxPropSelectedDropDown(row.PropertyId) >= 0) {
                toReturn = true;
            } else {
                allSelected = false;
            }
        }
        if (allSelected) return false;
        else return toReturn;
    }

    MasterToggle($event: any) {
        for (let row of this.lstProperties) {
            this.onPropertySelected(row.PropertyId, $event);
        }
    }

    Transform_TopFilter(lst: any): void {
        let totalCount = 0;

        if (lst == null) {
            //console.info("A = " + this.PropStatModel.length);
            for (let i = 0; i < this.PropStatModel.length; i++) {
                let row = this.PropStatModel[i];

                if (row != null && row.Id != null) {
                    totalCount = totalCount + row.Value;
                }
            }
        } else {
            for (let i = 0; i < this.PropStatModel.length; i++) {
                let row = this.PropStatModel[i];

                if (row != null && row.Id != null) {
                    // converting number to string, because StatusCode in response is a string and number in request
                    const rowStr = "" + row.Id;
                    let count = alasql(
                        "Select SUM([Count]) as cnt from ? where StatusCode = ?",
                        [lst, rowStr]
                    );

                    row.Value = count[0].cnt;
                    totalCount = totalCount + row.Value;
                }
            }
        }

        //console.info("T = " + totalCount);

        this.FindStatus(null).Value = totalCount;
    }

    SetTopStatusData(): void {
        this.glitchService
            .Glitch_Search_Counts(this.RequestModel)
            .then((data) => {
                this.Transform_TopFilter(data);
            });
    }

    onTopFilter(StatusCode: any): void {
        this.RequestModel.Status = StatusCode;
        this.SetTopStatusData();
        this.SetData();
    }

    onPropertyOpened(val: any): void {
        if (val == true)
            this.SelectedProperties = _.cloneDeep(this.RequestModel.Properties);
    }

    idxPropSelectedDropDown(PropertyId: number): number {
        return this.SelectedProperties.findIndex((a) => a == PropertyId);
    }

    onPropertySelected(PropertyId: number, eventData: any): void {
        let idx = this.idxPropSelectedDropDown(PropertyId);

        if (eventData.target.checked) {
            if (idx >= 0) return;

            this.SelectedProperties.push(PropertyId);
        } else {
            if (idx >= 0) {
                this.SelectedProperties.splice(idx, 1);
            }
        }
    }

    isPropSelected(id: number): boolean {
        if (this.RequestModel == null || this.RequestModel.Properties == null)
            return false;

        return this.RequestModel.Properties.findIndex((a) => a == id) >= 0;
    }

    onPropertyChange(): void {
        //this.RequestModel.PropertyId = PropertyId;
        if (this.SelectedProperties.length == 0) this.SetSearchProperties();

        this.RequestModel.Properties = _.cloneDeep(this.SelectedProperties);
        this.onClearFilter();
        this.SetTopStatusData();
        this.SetData();
        this.CreateCache();
    }

    SetData(): void {
        let pCode = this.RequestModel.Status;
        this.glitchService.SelectedGlitch = null;

        if (this.RequestModel.GroupBy == GlitchSearch_GroupBy.None) {
            this.grdSearchResult.RequestModel = this.RequestModel;
            this.grdSearchResult.Show();
            return;
        }

        this.glitchService.SelectedGlitch = null;
        this.IsSubmitting = true;

        this.Model = new ListResponse();
        this.Model.Result = [];

        this.glitchService
            .Glitch_Search(this.RequestModel)
            .then((data) => {
                //console.info(data);

                this.Model = data;
                this.RequestModel.PageNumber = data.CurrentPage;
                this.IsSubmitting = false;
            })
            .catch((reason) => {
                this.IsSubmitting = false;
            });
    }

    onLoggedToMe(): void {
        //this.RequestModel.LoggedBy = [this.masterService.LoggedInUserData.StaffId];
        //this.RequestModel.AssignedTo = [];
        this.SetData();
    }

    onFilter(row: GenericMaster_String): void {
        this.RequestModel.OrderBy = row.Id;
        this.SetData();
    }

    onClearGrouping() {
        this.RequestModel.GroupBy = GlitchSearch_GroupBy.None;
        this.onGroupingChanged();
    }

    CreateCache(): void {
        this.MasterCache[EntityCodes.Location] = [];
        this.MasterCache[EntityCodes.GlitchDescriptionMaster] = [];
        this.MasterCache[EntityCodes.GlitchCategories] = [];
        this.MasterCache[EntityCodes.Staff] = [];
        this.MasterCache[EntityCodes.Dept] = [];
        this.MasterCache[EntityCodes.GlitchActionReason] = [];

        for (let i = 0; i < this.RequestModel.Properties.length; i++) {
            let propID = this.RequestModel.Properties[i];

            let objProp =
                this.masterService.Cache_PropertyMainMasters.getValue(propID);

            if (objProp != null) {
                let res: Array<any>;

                this.MasterCache[EntityCodes.Location] = this.MasterCache[
                    EntityCodes.Location
                ].concat(objProp.Location);
                this.MasterCache[EntityCodes.GlitchDescriptionMaster] =
                    this.MasterCache[
                        EntityCodes.GlitchDescriptionMaster
                    ].concat(
                        alasql(
                            "Select * from ? where Id not in (Select Id from ?)",
                            [
                                objProp.GlitchDescriptionMaster,
                                this.lstGlitchDescription,
                            ]
                        )
                    );
                this.MasterCache[EntityCodes.GlitchCategories] =
                    this.MasterCache[EntityCodes.GlitchCategories].concat(
                        alasql(
                            "Select * from ? where Id not in (Select Id from ?)",
                            [objProp.GlitchCategories, this.lstGlitchCategories]
                        )
                    );
                this.MasterCache[EntityCodes.Staff] = this.MasterCache[
                    EntityCodes.Staff
                ].concat(
                    alasql(
                        "Select * from ? where Id not in (Select Id from ?)",
                        [objProp.Staff, this.lstStaff]
                    )
                );
                this.MasterCache[EntityCodes.Dept] = this.MasterCache[
                    EntityCodes.Dept
                ].concat(
                    alasql(
                        "Select * from ? where Id not in (Select Id from ?)",
                        [objProp.Dept, this.lstDepartments]
                    )
                );
            }
        }
    }

    SearchFilter_DisplayText(value: SearchTextResult): string {
        if (value == null) return "";

        if (typeof value !== "object") return value;

        return value.Term;
    }

    SearchString = (term$: Observable<string>) =>
        term$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            //tap(() => this.searching = true),
            switchMap((term) =>
                this.onSearch(term).pipe(
                    //tap(() => this.searchFailed = false),
                    catchError(() => {
                        //this.searchFailed = true;
                        return of([]);
                    })
                )
            )
            //tap(() => this.searching = false)
        );

    SearchOnList(term: string, Entity: EntityCodes): SearchTextResult {
        let res = new SearchTextResult();
        res.Entity = Entity;
        res.EntityName = Entity.toString();
        res.Term = term;
        res.ItemCount = 0;

        let lst: Array<any> = this.MasterCache[Entity];
        if (lst == null || lst.length == 0) return res;

        let str = term.toUpperCase();
        let count: number = 0;

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];

            let name = "";

            switch (Entity) {
                case EntityCodes.GlitchCategories:
                case EntityCodes.GlitchDescriptionMaster:
                case EntityCodes.Location:
                    name = row.Description;
                    break;
                case EntityCodes.Staff:
                case EntityCodes.Dept:
                    name = row.Name;
            }

            if (name != null && name.length > 0) {
                if (name.toUpperCase().indexOf(str) >= 0) {
                    count++;
                }
            }
        }

        res.ItemCount = count;

        return res;
    }

    SearchOnList_GetItems(term: string, Entity: EntityCodes): Array<number> {
        let res = new Array<number>();

        let lst: Array<any> = this.MasterCache[Entity];
        if (lst == null || lst.length == 0) return res;

        let str = term.toUpperCase();

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];

            let name = "";

            switch (Entity) {
                case EntityCodes.GlitchCategories:
                    name = row.Description;
                    break;
                case EntityCodes.GlitchDescriptionMaster:
                    name = row.Description;
                    break;
                case EntityCodes.Location:
                    name = row.Description;
                    break;
                case EntityCodes.Staff:
                    name = row.Name;
                    break;
                case EntityCodes.Dept:
                    name = row.Name;
            }

            if (name != null && name.length > 0) {
                if (name.toUpperCase().indexOf(str) >= 0) {
                    res.push(row.Id);
                }
            }
        }

        return res;
    }

    onSearch(term: string): any {
        let result: Array<SearchTextResult> = [];
        if (term == null || term.length == 0) {
            return of(result);
        }
        if (term == null || term.length <= 2) {
            if (_.toNumber(term) >= 0) {
                let rCN = new SearchTextResult();
                rCN.Entity = EntityCodes.Glitch;
                rCN.EntityName = "GlitchCallNo";
                rCN.Term = term;
                rCN.ItemCount = 0;

                result.push(rCN);
            }

            return of(result);
        }

        this.SearchOnEntities.map((ent) => {
            let row = this.SearchOnList(term, ent);
            if (row.ItemCount > 0) result.push(row);
        });

        let rG = new SearchTextResult();
        rG.Entity = EntityCodes.None;
        rG.EntityName = "Guests";
        rG.Term = term;
        rG.ItemCount = 0;

        result.push(rG);

        let nTerm: any = term;

        //console.info(_.toNumber(term));

        if (_.toNumber(term) >= 0) {
            let rCN = new SearchTextResult();
            rCN.Entity = EntityCodes.Glitch;
            rCN.EntityName = "GlitchCallNo";
            rCN.Term = term;
            rCN.ItemCount = 0;

            result.push(rCN);
        }

        return of(result);
    }

    onSearchFilter(sel: NgbTypeaheadSelectItemEvent): void {
        let data: SearchTextResult = sel.item;

        let pCode = this.RequestModel.Status;

        this.RequestModel = new Glitch_SearchRequest();
        this.RequestModel.SetDefaults();

        this.RequestModel.Status = pCode;

        this.SetSearchProperties();

        this.RequestModel.GuestName = null;

        let req = this.RequestModel;

        let res = this.SearchOnList_GetItems(data.Term, data.Entity);

        switch (data.Entity) {
            case EntityCodes.GlitchCategories:
                req.GlitchCategories = res;
                break;
            case EntityCodes.GlitchDescriptionMaster:
                req.GlitchDescriptions = res;
                break;
            case EntityCodes.Location:
                req.Locations = res;
                break;
            case EntityCodes.Staff:
                req.GlitchStaffs = res;
                break;
            case EntityCodes.Dept:
                req.Departments = res;
                break;
            case EntityCodes.Glitch:
                req.GlitchCallNo = _.toNumber(data.Term);
                break;
            case EntityCodes.None:
                req.GuestName = data.Term;
                break;
        }

        this.SetData();
    }

    onSelected(Model: any): void {
        this.glitchService.SelectedGlitch = Model;
    }

    onGroupingChanged(): void {
        this.SetData();
    }

    onClearFilter(): void {
        let currentGrouping = this.RequestModel.GroupBy;
        this.InitRequestModel();
        this.KeywordSearch = null;
        if (currentGrouping !== GlitchSearch_GroupBy.None) {
            this.RequestModel.GroupBy = currentGrouping;
        }
        this.SetData();
        this.SetTopStatusData();
    }

    onResetToAll(): void {
        this.InitRequestModel();
        this.KeywordSearch = null;
        this.RequestModel.Status = null;
        this.SetData();
    }

    RefreshData(): void {
        this.SetTopStatusData();
        this.SetData();
    }

    onFilterSave(): void {
        if (this.RequestModel == null) return;

        let data = _.cloneDeep(this.RequestModel);
        data.PageNumber = 1;

        let str = JSON.stringify(data);

        let req = new Filter_Update_Request();
        req.EntityCode = EntityCodes.Glitch;
        req.JSONData = str;

        this.userService.Filter_Update(req).then((data) => {
            this.GetMultilingualToast("TS.TS_GENERAL_SAVED", "success");
        });
    }

    onLoadFilter(): void {
        let req = EntityCodes.Glitch;

        this.userService.FilterSave_GetJSON(req).then((data) => {
            if (data == null) {
                //if (this.Model == null)
                //    this.SetData();

                return;
            }
            data.Properties = data.Properties.filter((a) =>
                this.masterService.CheckActiveLicence_Module(
                    a,
                    ModuleLicenceCodes.TritonRapidResponse
                )
            );
            if (data.Properties.length > 0) {
                let obj: any = data;
                this.RequestModel = new Glitch_SearchRequest();
                this.RequestModel.SetDefaults();
                this.RequestModel = _.assign(this.RequestModel, obj);
                if (this.RequestModel.GuestName)
                    this.KeywordSearch = this.RequestModel.GuestName;
                if (this.RequestModel.GlitchCallNo)
                    this.KeywordSearch =
                        this.RequestModel.GlitchCallNo.toString();
                this.SelectedProperties = _.cloneDeep(
                    this.RequestModel.Properties
                );
                this.SetData();
                this.SetTopStatusData();
            }
        });
    }
    OpenKeyModal(): void {
        let ngbModalOptions: NgbModalOptions = {
            backdrop: "static",
            size: "lg",
            centered: true,
        };
        this.modalService.open(this.glConsoleKey, ngbModalOptions);
    }
}
